import styled from 'styled-components';

/**
 * Where tasks are due on the calendar: a small soft dot (Petr, 2026-10-09: the 🏁 "looks awful", and a flag already
 * means priority; picked from mock-ups, in grey rather than near-black). With two or more tasks due at once it grows
 * just enough to hold their count, which goes inside it.
 */
export const DueDot = styled.span<{ $count?: number }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  ${({ $count }) =>
    $count && $count > 1
      ? 'min-width: 14px; height: 14px; padding: 0 3px; border-radius: 7px;'
      : 'width: 8px; height: 8px; border-radius: 50%;'}
  background-color: ${({ theme }) => theme.textColor}99;
  color: ${({ theme }) => theme.background};
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  transition: background-color 0.15s ease;
`;
